// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__30G_v","list":"BalanceDue_list__rgA6w","listRow":"BalanceDue_listRow__1aO7a","total":"BalanceDue_total__JDLHF"};